export class Register {
    id: string;
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    role: number;
}